import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface MainProps {
  bgColor?: string;
}

const Main = styled.main<MainProps>`
  width: 100%;
  margin: auto;
  background-color: ${({ bgColor }) => bgColor || 'transparent'};
`;

interface AppLayoutProps {
  header: ReactNode;
  children: ReactNode;
  bgColor?: string;
}

const AppLayout = ({ header, children, bgColor }: AppLayoutProps) => {
  return (
    <>
      {header}
      <Main bgColor={bgColor}>{children}</Main>
    </>
  );
};

export default AppLayout;
